import { apiRequest } from '@/lib/api-client';
import type { LoginRequest, LoginResponse } from '@/types/auth';

export const login = (payload: LoginRequest) => {
  return apiRequest<LoginResponse>('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
};
